import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { FormHandles } from '@unform/core'
import { Alert, IconInfo } from '@vtex/shoreline'

import { Button } from '~/components/Buttons'
import Panel from '~/components/Panel'
import { FormGroup, Input, Label } from '~/components/unform'
import { sanitizeAndFormatName } from '~/helpers'
import useModal from '~/hooks/useModal'

import BestPracticesModal from './BestPracticesModal'

type FormMainInfoProps = {
  formRef: React.RefObject<FormHandles>
}

const FormMainInfo: React.FC<FormMainInfoProps> = ({ formRef }) => {
  const { t } = useTranslation()

  const [Modal, isShowing, toggle] = useModal()

  const handleChangeName = useCallback(
    (data: InputOnChangeData) => {
      const callback = (value: string) =>
        formRef?.current?.setFieldValue('name', value)

      sanitizeAndFormatName(data.value, callback)
    },
    [formRef]
  )

  return (
    <>
      <Modal
        title={t('rm:placements.bestPractices.modal.title')}
        isOpen={isShowing}
        onClose={toggle}
      >
        <BestPracticesModal />
      </Modal>

      <Panel>
        <FormGroup className="span2">
          <div className="d-flex justify-content-between">
            <Label
              text={t('rm:placements.form.name.label')}
              helperText={t('rm:placements.form.name.labelHelperText')}
              htmlFor="name"
              isRequired
            />
            <Button
              iconLeft={<IconInfo />}
              text={t('rm:placements.bestPractices.button.text')}
              size="small"
              template="secondary"
              onClick={toggle}
            />
          </div>
          <Input
            name="name"
            placeholder={t('rm:placements.form.name.placeholder')}
            required
            onChange={handleChangeName}
          />
          <Alert variant="informational">
            {t('rm:placements.form.name.warning')}
          </Alert>
        </FormGroup>

        <FormGroup className="span-start">
          <Label
            text={t('rm:placements.form.full_name.label')}
            htmlFor="full_name"
            helperText={t('rm:placements.form.full_name.labelHelperText')}
          />
          <Input
            name="full_name"
            placeholder={t('rm:placements.form.full_name.placeholder')}
          />
        </FormGroup>

        <FormGroup>
          <Label
            text={t('rm:placements.form.description.label')}
            helperText={t('rm:placements.form.description.labelHelperText')}
            htmlFor="description"
          />
          <Input
            name="description"
            placeholder={t('rm:placements.form.description.placeholder')}
          />
        </FormGroup>
      </Panel>
    </>
  )
}

export default FormMainInfo
